//import * from "../js/menu.js";
import { Main } from "./main";
import { Helpers } from "./helpers";
import { DealerLocator }  from "./dealer-locator";
import Blocks from "./blocks";
import { MultiColumnBlock } from "./blocks/multicolumn-block";
import { TabHolderBlock } from "./blocks/tabholder-block";
import { InpageMenuHolderBlock } from "./blocks/inpagemenuholder-block";

declare global {
    interface Array<T> {
        find(predicate: (search: T) => boolean): T;
    }
    interface Window {
        dataLayer: any;
    }
}

export class Application {
    constructor() {
        (window as any).Helpers = new Helpers();

        if (!Array.prototype.find) {
            Array.prototype.find = function (predicate) {
                if (this == null) {
                    throw new TypeError('Array.prototype.find called on null or undefined');
                }
                if (typeof predicate !== 'function') {
                    throw new TypeError('predicate must be a function');
                }
                var list = Object(this);
                var length = list.length >>> 0;
                var thisArg = arguments[1];
                var value;

                for (var i = 0; i < length; i++) {
                    value = list[i];
                    if (predicate.call(thisArg, value, i, list)) {
                        return value;
                    }
                }
                return undefined;
            };
        };
        
        (window as any).Main = new Main();
        (window as any).Main.init();

        new Blocks();
        
        var tabholder = new TabHolderBlock();
        var inpagemenuholder = new InpageMenuHolderBlock();
        var multiColumnBlock = new MultiColumnBlock();

        (<any>window).initMap = function () {
            new DealerLocator().init();
        }
    }
}

let application = new Application();